import React from "react";

import styled from "styled-components";
import { Typography } from "@mui/material";

export const StyledCustomerTypography = styled<typeof Typography>((props) => (
    <Typography
        color="var(--color-grey-900)"
        fontSize={{ xs: "var(--size-12)", sm: "var(--size-16)" }}
        my={1}
        {...props}
    />
))`
    a {
        text-decoration: underline;
        cursor: pointer;
    }
`;
